import { useState, createContext } from "react";

let AppContext = createContext();

const AppContextProvider = ({ children }) => {
  const [cartValue, setCartValue] = useState({ count: 0 });
  const [companyInfo, setCompanyInfo] = useState({});
  const [tip, setTip] = useState([]);

  return (
    <AppContext.Provider
      value={{ cartValue, setCartValue, companyInfo, setCompanyInfo, tip, setTip }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
export { AppContextProvider };
